export interface UiSuggestionItem {
    isSponsored?: boolean;
    url: string;
    title: string;
    count?: string;
    picture?: string;
}

export const SUGGESTION_TYPE = {
    CATEGORY: 'CATEGORY',
    PRODUCT: 'PRODUCT',
    SERVICE: 'SERVICE',
    COMPLETION: 'COMPLETION',
} as const;

export type SuggestionType =
    (typeof SUGGESTION_TYPE)[keyof typeof SUGGESTION_TYPE];

export type UiSuggestionSection = {
    type: SuggestionType;
    items: UiSuggestionItem[];
};

export type UiSuggestions = {
    suggestionItems: UiSuggestionSection[];
    redirectUri: string | null;
};

export type ZtNav = {
    product_id: number;
    viewed_time: number;
};

export interface HoppsSuggestionsApiCategoryItem {
    categoryTitle: string;
    path: string;
    count: number;
    parentCategoryTitle?: string;
}

export interface HoppsSuggestionsApiProductItem {
    name: string;
    path: string;
    pictureUrl: string;
    shopIdentifier: number;
    isSponsored: boolean;
}

export interface HoppsSuggestionsApiPageItem {
    display: string;
    targetUrl: string;
    redirect: boolean;
}

export interface HoppsSuggestionsApiResponse {
    requestId: string;
    redirectUri: string | null;
    categories: HoppsSuggestionsApiCategoryItem[];
    products: HoppsSuggestionsApiProductItem[];
    pages: HoppsSuggestionsApiPageItem[];
}
